import React, { useEffect, useState, useRef } from 'react';
import "./styles.less"

const country = {
    "1": {
        flag: "https://cdn1.infocasas.com.uy/web/650cb8979c579_banderas-(1).png"
    },
    "2": {
        flag: "https://cdn1.infocasas.com.uy/web/6514dd6903792_banderas-(2).png"
    },
    "3": {
        flag: "https://cdn1.infocasas.com.uy/web/6514dcc28c91a_banderas-(4).png"
    },
    "4": {
        flag: "https://cdn1.infocasas.com.uy/web/6514dcc28d950_banderas-(3).png"
    },
    "5": {
        flag: "https://cdn1.infocasas.com.uy/web/65146f135702d_banderas-bolivia.png"
    }
}

export const Carousel = ({ data, ItemComponent }) => {
    const carouselRef = useRef(null);
    const [cardPerView, setCardPerView] = useState(null);

    useEffect(() => {
        const carousel = carouselRef.current;
        const firstCardWidth = carousel.querySelector(".card").offsetWidth;
        const arrowBtns = document.querySelectorAll(".wrapper .chevron");

        setCardPerView(Math.round(carousel.offsetWidth / firstCardWidth));

        carousel.classList.add("no-transition");
        // carousel.scrollLeft = carousel.offsetWidth;
        carousel.classList.remove("no-transition");

        arrowBtns.forEach((btn) => {
            btn.addEventListener("click", () => {
                carousel.scrollLeft += btn.id === "left" ? -firstCardWidth : firstCardWidth;
            });
        });

        return () => {
            arrowBtns.forEach((btn) => {
                btn.removeEventListener("click", () => {
                    carousel.scrollLeft += btn.id === "left" ? -firstCardWidth : firstCardWidth;
                });
            });
        };
    }, [cardPerView]);

    return (
        <div className="wrapper">
            <button className="prev chevron" id="left">
                <span className="material-icons">chevron_left</span>
            </button>

            <ul
                className="carousel"
                ref={carouselRef}
            >
                {data.map((item, index) => (
                    <li className="card" key={index}>
                        <ItemComponent data={item} />
                    </li>
                ))}
            </ul>
            <button className="next chevron" id="right">
                <span className="material-icons">chevron_right</span>
            </button>
        </div>
    );
};